import { DebugDetailSection } from 'modules';



export type CompanyHealthActivityProps = {};

export const CompanyHealthActivity = (props: CompanyHealthActivityProps) => {
  return (
    <DebugDetailSection.FC />
  );
};
